import { ApexOptions } from "apexcharts";
import Chart from "react-apexcharts";
import React from "react";

interface WatchlistSparklineProps {
  data: string[];
}
const WatchlistSparkline = (props: WatchlistSparklineProps) => {
  const { data } = props;

  const options: ApexOptions = {
    chart: {
      type: "area",
      sparkline: {
        enabled: true,
      },
      animations: { enabled: false },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#FC4C4C", "#FCF6EB"],
    stroke: {
      show: true,
      curve: "smooth",
      colors: ["#fee8e8"],
      width: 1,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
    },
    tooltip: { enabled: false },
  };

  const [isLargeScreen, setIsLargeScreen] = React.useState<boolean>(false);
  React.useEffect(() => {
    const handleResize = () => {
      // Check the current width of the window
      const screenWidth = window.innerWidth;
      // Define the minimum width you want to check against (1800px)
      const minWidth = 1800;
      // Update state based on screen width
      setIsLargeScreen(screenWidth >= minWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Call handleResize once on component mount to set initial state
    handleResize();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array means this effect runs only once on mount

  return (
    <Chart
      type="area"
      series={[
        {
          data: data.slice(-14).map(parseFloat),
        },
      ]}
      options={options}
      width={isLargeScreen ? "90%" : "150"}
      height="25px"
    />
  );
};

export default WatchlistSparkline;
